export default {
  header: {
    notes: 'Activities page title',
    message: 'Activities',
  },
  empty: {
    text: {
      notes: 'Text of empty state when no activities exist',
      message: 'No activities exists. Create the first one!',
    },
  },
};
